/**
 * OpenApi for Bazargah Project - this.farzad.null
 *
 * Contact: f.gilaki9876@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppUserGetAccountRec { 
    id?: string;
    username?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    identity?: string;
    shahkarVerified?: boolean;
    userType?: AppUserGetAccountRecUserTypeEnum;
    legalAccountStatus?: AppUserGetAccountRecLegalAccountStatusEnum;
    companyName?: string;
    role?: string;
    referralCode?: string;
    referredBy?: string;
    unsignedAgreements?: Array<string>;
    acceptedSimpleAgreements?: Set<string>;
    userCreationDate?: string;
    profileImageFileId?: string;
}
export enum AppUserGetAccountRecUserTypeEnum {
    Legal = 'LEGAL',
    Real = 'REAL'
};
export enum AppUserGetAccountRecLegalAccountStatusEnum {
    PendingApproval = 'PENDING_APPROVAL',
    Approved = 'APPROVED',
    Rejected = 'REJECTED'
};



